import script from "./schedule-details.vue?vue&type=script&setup=true&lang=js"
export * from "./schedule-details.vue?vue&type=script&setup=true&lang=js"

import "./schedule-details.vue?vue&type=style&index=0&id=0c6011bb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c6011bb"]])

export default __exports__